export const ANALYTICS_KEYS = {
    // user attributes
    STUDENT_NAME: 'student_name',
    DOB: 'dob',
    // roll_no /roll_number
    ROLL_NUMBER: 'roll_number',
    UUID: 'uuid',

    //
    CLASS_STUDYING: 'class_studying',
    BRANCH_CODE: 'branch_code',
    STREAM: 'stream',
    TEST_TYPE: 'test_type',
    EXAM_TYPE: 'exam_type',

    SUCCESS: 'success',
    QUESTION_ID: 'question_id',
    QUESTION_TYPE: 'question_type',
    OPTIONS_SELECTED: 'options_selected',

    USER_TEST_ID: 'user_test_id',

    SECTION_NAME: 'section_name',
    LANGUAGE: 'language',
    EXTERNAL_ID: 'external_id',
    FAILURE: 'failure',
    REASON_FOR_FAILURE: 'reason_for_failure',
    TEST_ID: 'test_id',
    TEST_RESULT: 'test_result',

    TEST_NAME: 'test_name',
    DURATION_OF_TEST: 'duration_of_test',
    TOTAL_QUESTIONS: 'total_questions',
    MAX_MARKS: 'max_marks',
    GRACE_PERIOD: 'grace_period',
    DISCONNECTION_TIME: 'disconnection_time',
    TEST_SHORT_CODE: 'test_short_code',
}
